import React, { useCallback, useContext, useEffect, useState } from 'react';
import { t } from 'i18next';
import { ThemeContext } from 'theme';
import useSwitchAppClubAccount from 'utils/useSwitchAppClubAccount';
import {
  getSingleClubRequest,
  postActiveClubInfoRequest,
  setActiveAccountId,
} from 'store/club/actions';
import { useDispatch, useSelector } from 'react-redux';
import { PrivateContentModal } from '../Modals/PrivateContentModal/PrivateContentModal';
import { useRouter } from 'next/router';
import { getUserDetailsStart } from 'store/user/actions';

const PrivateContent = ({
  data,
  showButton,
  buttonText,
  onButtonClick,
}: any) => {
  const dispatch = useDispatch();
  const [modalContent, setModalContent] = useState({
    headerText: '',
    bodyText: '',
  });
  const { handleClubSwitch } = useSwitchAppClubAccount();
  const context: any = useContext(ThemeContext);
  const { isAuthenticate, user } = context;
  const router = useRouter();
  const { clubJoiningToken } = router.query;
  const userDetails = useSelector((store) => store.user?.userDetails);
  const allClubs = useSelector((state: any) => state?.club?.allClubs);
  const clubId =
    data?.clubs?.find((eventClub: string) =>
      user?.clubs?.includes(eventClub)
    ) ?? (data?.clubs?.length ? data.clubs[0] : undefined);

  const isPrivateAccess = data?.isPrivateAccess;

  const activeClub = allClubs?.find((_club) => _club?._id === clubId);

  useEffect(() => {
    if (clubId) {
      const userId = localStorage.getItem('user_id');
      dispatch(getUserDetailsStart(userId));
      if (
        userDetails?._id &&
        !userDetails?.clubRoles?.find((club) => club.clubId === clubId) &&
        clubJoiningToken
      ) {
        const redirectPath = router.asPath.split('?')[0];
        router.push({
          pathname: '/joinClub',
          query: {
            id: clubId,
            token: clubJoiningToken,
            redirect: redirectPath,
          },
        });
        return;
      } else dispatch(getSingleClubRequest({ clubId }));
    }
  }, [clubId, dispatch, userDetails]);

  useEffect(() => {
    if (activeClub && isPrivateAccess) {
      setModalContent({
        headerText: `${t('event:thisBelongto')} ${activeClub?.name || 'Club'}`,
        bodyText: `${t('event:switchTo')} ${activeClub?.name || 'Club'}...`,
      });
      dispatch(setActiveAccountId(clubId));
    } else if (isPrivateAccess) {
      setModalContent({
        headerText: t('event:privateContent'),
        bodyText: t('event:thisContentisPrivate'),
      });
    }
  }, [activeClub, isAuthenticate, handleClubSwitch]);
  return (
    <>
      {data?.isPrivateAccess ? (
        <PrivateContentModal
          headerText={modalContent.headerText}
          bodyText={modalContent.bodyText}
          showButton={showButton}
          buttonText={buttonText}
          onButtonClick={onButtonClick}
        />
      ) : null}
    </>
  );
};

export default PrivateContent;
